import { jsx as _jsx } from "react/jsx-runtime";
import { PaymentGroupName } from '@as-react/common-types';
import { PaymentRequestGroupContent } from './PaymentRequestGroupContent';
import { useCheckoutConfig } from '../../../context/CheckoutContext';
export const PaymentRequestGroupGeneric = ({ group, selected, onSubmit }) => {
    const { payPalInfoMessage } = useCheckoutConfig();
    const hint = group.name === PaymentGroupName.PAYPAL ? payPalInfoMessage : undefined;
    return _jsx(PaymentRequestGroupContent, { onSubmit: () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(), selected: selected, hint: hint, group: group });
};
